import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const oilRequirementApi = createApi({
  reducerPath: 'oilRequirementApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/OilRequirement`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['OilRequirement'],
  endpoints: (builder) => ({
    getOilRequirements: builder.query({
      query: (params) => ({
        url: '/',
        params,
      }),
      providesTags: ['OilRequirement'],
    }),
    getOilRequirementById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: 'OilRequirement', id }],
    }),
    getUniqueBrands: builder.query({
      query: () => '/brands',
      providesTags: ['OilRequirement'],
    }),
    getModelsByBrand: builder.query({
      query: (brand) => `/brands/${brand}/models`,
      providesTags: ['OilRequirement'],
    }),
    createOilRequirement: builder.mutation({
      query: (data) => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['OilRequirement'],
    }),
    updateOilRequirement: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'OilRequirement', id }, 'OilRequirement'],
    }),
    deleteOilRequirement: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['OilRequirement'],
    }),
  }),
});

export const {
  useGetOilRequirementsQuery,
  useGetOilRequirementByIdQuery,
  useGetUniqueBrandsQuery,
  useGetModelsByBrandQuery,
  useCreateOilRequirementMutation,
  useUpdateOilRequirementMutation,
  useDeleteOilRequirementMutation,
} = oilRequirementApi;

export default oilRequirementApi;
